import { z } from "zod";

export const applyOddSchema = z.object({
  start_date: z
    .union([z.date(), z.null()]) // Allow null for the date field
    .refine((val) => val !== null, {
      message: "Start Date is required",
    }),
  end_date: z
    .union([z.date(), z.null()]) // Allow null for the date field
    .refine((val) => val !== null, {
      message: "End Date is required",
    }),
  odd_type: z
    .string({
      required_error: "Odd type is required",
      invalid_type_error: "Odd type must be a string",
    })
    .nonempty("Odd type is required")
    .refine(
      (value) => ["FD", "HDF", "HDS"].includes(value),
      "Invalid odd type"
    ),
  reason: z
    .string({
      required_error: "Reason is required",
      invalid_type_error: "Reason must be a string",
    })
    .trim()
    .nonempty("Reason is required"),
});
